import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CertificationInterface } from '../../interfaces/certification.interface';
import { ScrollAnimationDirective } from '../../directives/scroll-animation.directive';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-certification-card',
  standalone: true,
  imports: [MatIconModule, ScrollAnimationDirective, TranslateModule],
  template: `
    <div class="certification-item" scrollAnimation>
      <div class="cert-icon">
        <mat-icon>{{certification.icon}}</mat-icon>
      </div>
      <h3>{{certification.title}}</h3>
      <p>{{certification.description}}</p>
    </div>
  `,
  styles: [`
    .certification-item {
      text-align: center;
      padding: 2rem;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 8px;
      backdrop-filter: blur(10px);
      transition: transform 0.3s ease;
      min-height: 260px; /* Added min-height to ensure consistent card heights */
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .certification-item:hover {
      transform: translateY(-5px);
    }

    .cert-icon {
      background: rgba(255, 255, 255, 0.2);
      width: 80px;
      height: 80px;
      border-radius: 50%;
      margin: 0 auto 1.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .cert-icon mat-icon {
      font-size: 40px;
      width: 40px;
      height: 40px;
    }

    h3 {
      margin-bottom: 1rem;
      font-size: 1.5rem;
    }
  `]
})
export class CertificationCardComponent {
  @Input() certification!: CertificationInterface;
  // translatedDescription: string = '';
  // constructor(private translate: TranslateService) {}

  // ngOnInit() {
  //   // Translate the certification description
  //   this.translate.get(this.certification.description).subscribe((translation: string) => {
  //     this.translatedDescription = translation;
  //   });

  //   // Update if language changes
  //   this.translate.onLangChange.subscribe(() => {
  //     this.translate.get(this.certification.description).subscribe((translation: string) => {
  //       this.translatedDescription = translation;
  //     });
  //   });
  // }
}
